/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free spinning decision wheel. Enter your own options and spin to pick one at random — settle choices, pick names or decide what to eat.`)
};

const es_dw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rueda de decisiones giratoria gratuita. Introduce tus propias opciones y gira para elegir una al azar — resuelve dudas, elige nombres o decide qué comer.`)
};

const de_dw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloses drehbares Entscheidungsrad. Gib deine eigenen Optionen ein und drehe, um zufällig eine auszuwählen — entscheide Streitfragen, wähle Namen oder entscheide, was es zu essen gibt.`)
};

const nl_dw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis draaiend beslisrad. Vul je eigen opties in en draai om er willekeurig één te kiezen — beslecht keuzes, kies namen of bepaal wat je gaat eten.`)
};

const fr_dw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roue de décision tournante gratuite. Saisissez vos propres options et faites tourner la roue pour en choisir une au hasard — tranchez des choix, tirez des noms ou décidez quoi manger.`)
};

const it_dw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruota della decisione gratuita. Inserisci le tue opzioni e fai girare la ruota per sceglierne una a caso — risolvi indecisioni, scegli nomi o decidi cosa mangiare.`)
};

const pt_br2_dw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roleta de decisão giratória gratuita. Informe suas próprias opções e gire para sortear uma aleatoriamente — resolva escolhas, sorteie nomes ou decida o que comer.`)
};

const pt_dw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roda de decisão giratória gratuita. Introduza as suas próprias opções e gire para escolher uma ao acaso — resolva dúvidas, escolha nomes ou decida o que comer.`)
};

const ja_dw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の回転式決定ホイール。自分の選択肢を入力してホイールを回し、ランダムに1つを選びます — 決断、名前選び、何を食べるか決めるのに便利です。`)
};

const zh_dw_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费旋转式决策转盘。输入你自己的选项，转动转盘随机选出一个——用来做决定、抽名字或决定吃什么。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dw_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dw_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dw_meta_description", locale)
	if (locale === "en") return en_dw_meta_description(inputs)
	if (locale === "es") return es_dw_meta_description(inputs)
	if (locale === "de") return de_dw_meta_description(inputs)
	if (locale === "nl") return nl_dw_meta_description(inputs)
	if (locale === "fr") return fr_dw_meta_description(inputs)
	if (locale === "it") return it_dw_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_dw_meta_description(inputs)
	if (locale === "pt") return pt_dw_meta_description(inputs)
	if (locale === "ja") return ja_dw_meta_description(inputs)
	return zh_dw_meta_description(inputs)
};